import { render } from "./OnboardingHeader.vue?vue&type=template&id=7896111e"
import script from "./OnboardingHeader.vue?vue&type=script&lang=js"
export * from "./OnboardingHeader.vue?vue&type=script&lang=js"

import exportComponent from "/home/api.muzea.ro/wp-content/themes/szmm/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__